@if (reordering()) {
  <th class="column-type-reorder"></th>
}

@for (column of columns(); track columnKey($index, column)) {
  <th
    pFrozenColumn
    app-table-filter-cell
    [frozen]="valueOrDefault(column.frozen, false)"
    [ngClass]="[column | columnTypeCssClass, column | columnKeyCssClass]"
    [column]="column"
    [filter]="filters() | filterConfigByKey: column.filterKey!"
    (filterChanges)="handleFilterChanges($event)"></th>
}

<ng-container>
  <th
    alignFrozen="right"
    class="column-type-actions"
    pFrozenColumn></th>
</ng-container>
